import React from 'react';
import { Dayjs } from 'dayjs';
import styles from './index.module.scss';
import forecastLogo from '../../assets/forecast-logo.png';
import forecastRing from '../../assets/ring-small.png';
import warningIcon from '../../assets/warning.png';
import { getForecastOption } from '../../chartOptions';
import { Point } from '../../type';
import ChartBlock from '../ChartBlock';
import SectionPanel from '../SectionPanel';

interface ForecastPanelProps {
  forecast: {
    actual: Point[];
    correction: { label: string; value: string }[];
    predict: Point[];
    warning: string;
  };
  selectedDate: Dayjs;
}

const ForecastPanel: React.FC<ForecastPanelProps> = ({ forecast, selectedDate }) => {
  return (
    <SectionPanel title="光伏预测（实际vs预测）">
      <div className={styles.forecastLayout}>
        <div className={styles.forecastChart}>
          <ChartBlock option={getForecastOption(forecast.actual, forecast.predict, selectedDate)} height={360} />
        </div>
        <aside className={styles.forecastAside}>
          <div className={styles.warningPanel}>
            <div className={styles.warningBox}>
              <span className={styles.warningIcon}>
                <img src={warningIcon} alt="" />
              </span>
              <span className={styles.warningTitle}>风险提示</span>
            </div>
            <div className={styles.warningContent}>{forecast.warning || '暂无提示'}</div>
          </div>
          <div className={styles.correctionBox}>
            <div className={styles.correctionHeader}>
              <img className={styles.correctionRing} src={forecastRing} alt="" />
              <img className={styles.correctionLogo} src={forecastLogo} alt="forecast logo" />
            </div>
            <div className={styles.correctionCards}>
              {forecast.correction.map(item => (
                <div className={styles.correctionCard} key={item.label}>
                  <span className={styles.correctionLabel}>{item.label}</span>
                  <span className={styles.correctionValue}>{item.value}</span>
                </div>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </SectionPanel>
  );
};

export default ForecastPanel;
